export default "__VITE_ASSET__CdjmFt29__"